<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Cotação</mat-card-title>
    </div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-8">
    <mat-card class="card-style px-4 py-6">
      <div class="flex justify-between gap-4 mb-4">
        <div class="w-1/4"><b>tg cod:</b> {{ item.tg }}</div>
        <div class="w-1/4"><b>Evento:</b> {{ item.nomeEvento }}</div>
        <div class="w-1/4">
          <b>Período:</b> {{ item.dataEventoInicio }} - {{ item.dataEventoFim }}
        </div>
        <div class="w-1/4"></div>
      </div>
      <div class="flex justify-between gap-4 mb-4">
        <div class="w-1/4"><b>Cliente:</b> {{ item.nome }}</div>
        <div class="w-1/4">
          <b>Subcliente:</b> {{ item.subClienteNome ?? '-' }}
        </div>
        <div class="w-1/4">
          <b>Consultor Cliente:</b> {{ item.consultorComercialNome }}
        </div>
        <div class="w-1/4">
          <b>Consultor Comercial:</b> {{ item.consultorNome ?? '-' }}
        </div>
      </div>
    </mat-card>
    <div class="mt-6">
      <!--  <form-client-search-->
      <!--    [search]="inputSearchContact"-->
      <!--    [listSearch]="listSearch"-->
      <!--    (responseSearch)="search($event)"-->
      <!--  />-->
      @if (!loading) {
        <div class="tab-overflow">
          <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
            @for (column of columns; track column.keyColumn) {
              <ng-container matColumnDef="{{ column.keyColumn }}">
                <th mat-header-cell *matHeaderCellDef>
                  {{ column.description }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (column.keyColumn == 'action') {
                    <div class="flex justify-center items-center gap-3">
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="edit"
                        matTooltip="Atualizar valor"
                        (click)="viewSuppliers(element)"
                      />
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="route"
                        matTooltip="Itinerários"
                        (click)="viewItinerariesItem(element)"
                      />
                      @if (!loadingFinish) {
                        <mat-icon
                          class="btn-icon-outline"
                          fontIcon="approval"
                          matTooltip="Encerrar Solicitação"
                          (click)="finishRequest(element)"
                        />
                      } @else {
                        <mat-spinner
                          diameter="24"
                          matTooltip="Encerrando Solicitação"
                        ></mat-spinner>
                      }
                    </div>
                  } @else if (column.keyColumn == 'location_OD') {
                    <!--                    <b>Origem: </b>{{ element.origem }}<br />-->
                    <!--                    <b>Destino: </b>{{ element.destino }}-->
                    <b>Origem</b><br />
                    Cidade: {{ element.cidadeOrigem }}<br />
                    Estado: {{ element.estadoOrigem }}<br />
                    <b>Destino</b><br />
                    Cidade: {{ element.cidadeDestino }}<br />
                    Estado: {{ element.estadoDestino }}
                  } @else if (column.keyColumn == 'servico_TS') {
                    <b>Tipo: </b>{{ element.tipoServico }}<br />
                    <b>Serviço: </b>{{ element.servico }}
                  } @else if (column.keyColumn == 'vehicle_VM') {
                    <b>Tipo veículo: </b>{{ element.tipoVeiculo }}<br />
                    <b>Tipo motorista: </b>{{ element.tipoMotorista }}
                  } @else if (column.keyColumn == 'period_date') {
                    <b>Inicio: </b>{{ element.itemDataInicio
                    }}{{
                      element.itemHoraInicio
                        ? ' - ' + element.itemHoraInicio
                        : ''
                    }}<br />
                    <b>Final: </b>{{ element.itemDataFinal }}
                    {{
                      element.itemHoraFinal ? ' - ' + element.itemHoraFinal : ''
                    }}
                  } @else if (column.keyColumn == 'itensComplete') {
                    <div class="text-center">
                      <b
                        [ngClass]="
                          element.totalCotacaoRealizada == element.totalCotacao
                            ? 'labelGreen'
                            : 'labelRed'
                        "
                        >{{ element.totalCotacaoRealizada }}/{{
                          element.totalCotacao
                        }}</b
                      >
                    </div>
                  } @else {
                    {{ element[column.key] }}
                  }
                </td>
              </ng-container>
            }
            <tr
              mat-header-row
              class="style-header"
              *matHeaderRowDef="displayedColumns"
            ></tr>
            <tr
              mat-row
              class="style-row"
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      <mat-paginator
        [hidden]="loading"
        #paginator
        [pageSize]="5"
        (page)="pageChanged($event)"
      >
      </mat-paginator>
    </div>
  </div>
</mat-card>
